import {FETCH_FILES, CLEAN_FILES, DELETE_FILE} from '../actions/types';

const FILES_DEFAULT_STATE = {};

const FilesReducer = (state = FILES_DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case FETCH_FILES:
            return payload;

        case CLEAN_FILES:
        case DELETE_FILE:
            return FILES_DEFAULT_STATE;

        default:
            return state;
    }
};

export default FilesReducer;
